import { Dialog } from '@mui/material';
import { UAParser } from '@ua-parser-js/pro-enterprise';
import * as React from 'react';

import muiStyles from './styles';
import { BrowserCheckModalProps } from './types';

const allowedBrowsers = [ 'Brave', 'Chrome', 'Edge', 'Opera' ];
const restrictedDevices = [ 'console', 'embedded', 'mobile', 'smarttv', 'tablet', 'wearable', 'xr' ];

export default function BrowserCheckModal(props: BrowserCheckModalProps) {
    const {
        applicationName,
        connected,
        logout
    } = props;

    const classes = muiStyles(props);
    const [ notChromeBrowser, setIsNonChromeBrowser ] = React.useState<boolean>(false);
    const sUsrAg = React.useMemo(() => navigator.userAgent, [navigator]);

    const checkBrowser = () => {
        // Microsoft Edge = Edg
        // Microsoft IE = Trident
        // Opera = Chrome
        // Google Chrome = Chrome
        // Mozilla FireFox = Firefox

        const parser = new UAParser();
        const result = parser.getResult();
        const browser = (result.browser.name ? result.browser.name : '');
        const device = (result.device.type ? result.device.type : '');
        if (allowedBrowsers.includes(browser) && !restrictedDevices.includes(device)) {
            setIsNonChromeBrowser(false);
        } else {
            setIsNonChromeBrowser(true);
        }
    };

    const continueWithBrowser = () => {
        setIsNonChromeBrowser(false);
        sessionStorage.setItem('non_chrome_browser', '1');
    };

    React.useEffect(() => {
        if (!connected) return;

        if (sessionStorage.getItem('non_chrome_browser') === '1') {
            setIsNonChromeBrowser(false);
        } else {
            checkBrowser();
        }
    }, [connected]);

    return (
        <Dialog
            disableEscapeKeyDown
            open={connected && notChromeBrowser}
        >
            <div className={classes.container}>
                <h1>Alert</h1>
                <p>
                    {applicationName || 'Tassat'} is exclusively supported on Chromium based browsers (i.e. Google Chrome or Microsoft Edge).
                    Using {applicationName || 'Tassat'} on other browsers, including Chrome for iOS,
                    is not supported and some functionality may be unavailable.
                </p>
                <p>
                    To download Google Chrome. <a href='https://www.google.com/chrome/'>click here.</a>
                </p>
                <p>
                    Thank you.
                </p>
                <div className={classes.buttonContainer}>
                    <button
                        className={classes.button}
                        onClick={continueWithBrowser}
                        type='button'
                    >
                        OK
                    </button>
                    <button
                        className={classes.button}
                        onClick={logout}
                        type='button'
                    >
                        Logout
                    </button>
                </div>
            </div>
        </Dialog>
    );
}